<template>
  <div>
    <v-snackbar
      color="error"
      right
      top
      :timeout="12000"
      :value="simulateAlertSnackbar"
    >
      {{ $t(`${eventPrefix}.save.form.simulete_alert`) }}
      <v-btn dark flat @click="simulateAlertSnackbar = false" icon
        ><v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <div>
      <v-toolbar color="white" tabs class="pt-3">
        <v-toolbar-title>
          <div>
            <span class="headline secondary--text">
              {{
                screener.id != undefined
                  ? $t(`${eventPrefix}.save.form.edit_title`)
                  : $t(`${eventPrefix}.save.form.title`)
              }}
            </span>
            <v-tooltip
              v-if="screener.id != undefined && screener.title"
              top
              color="greyDarken1"
            >
              <template v-slot:activator="{ on }">
                <span v-on="on" > / {{ screener.title | truncate(55) }}</span>
              </template>
              <span class="white--text body-1">{{ screener.title }}</span>
            </v-tooltip>
          </div>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
        v-if="screener.id && !is_vod_event && screener.event_type != DEFINES.SCREENER_TYPE.PHYSICAL && screener.screening_type != DEFINES.SCREENING_PLAN_TYPE.ENTERPRISE"
        small
        outline
        color="primary"
        @click="seatsDialog = true">
        {{$t('screener.btn.add_seats')}}</v-btn>
        <EmbedScreener v-if="screener.id" :screener="screener"></EmbedScreener>
        <ScreenerPreviewLink
          :screener="screener"
          :company="selected_company"
          :is_media_available="is_media_available"
        ></ScreenerPreviewLink>

        <template v-slot:extension>
          <v-tabs
            v-model="parentTabItem"
            color="transparent"
            slider-color="primary"
            grow
          >
            <v-tab href="#overview">{{
              $t(`${eventPrefix}.overview.title`)
            }}</v-tab>
            <v-tab href="#details">{{
              $t(`${eventPrefix}.about_screening.title`)
            }}</v-tab>
            <v-tab v-if="!is_vod_event && isPhysicalEvent(false)" href="#virtual" >{{$t('defines.screener_type_str.virtual')}}</v-tab>
            <v-tab v-if="!is_vod_event && isPhysicalEvent(true)" href="#physical">{{$t('defines.screener_type_str.physical')}}</v-tab>
             <v-tab
              v-if="is_vod_event"
              href="#vod_registrants"
              >{{ $t(`${eventPrefix}.save.registrant.title`) }}</v-tab
            >
          </v-tabs>
        </template>
      </v-toolbar>

      <v-tabs-items v-model="parentTabItem">
        <v-tab-item value="overview">
          <screener-overview
            v-if="screener.id && parentTabItem == 'overview'"
            :seatsStatus="allSeatsStatus"
            :screener="screener"
            :total_attendees="total_attendees"
          ></screener-overview>
          <v-card v-else class="pa-5" height="100%">
            <v-container
              class="pa-5"
              bg
              fill-height
              grid-list-md
              text-xs-center
            >
              <v-layout row wrap align-center>
                <v-flex v-if="loader">
                  <v-progress-circular
                    :size="70"
                    color="info"
                    class="overflow-hidden"
                    indeterminate
                  ></v-progress-circular>
                </v-flex>
                <v-flex v-else>
                  <span class="grey--text">{{
                    $t(`${eventPrefix}.save.overview.section.not_available`)
                  }}</span>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-tab-item>
        <v-tab-item value="details">
          <v-form>
            <v-stepper v-model="parentStepperStep" vertical>
              <v-stepper-step
                step="1"
                editable
                :rules="[() => common_stepper_validation]"
              >
                {{ $t("screener.save.step.basic_configuration") }}
              </v-stepper-step>
              <v-stepper-content step="1">
                <ScreenerCommonSave
                  :is_vod_event="is_vod_event"
                  :screener.sync="screener"
                  :eventPrefix="eventPrefix"
                  :screening_type="screening_type"
                  :uploaded_thumbnail_id.sync="uploaded_thumbnail_id"
                  :common_stepper_validation.sync="common_stepper_validation"
                  @goToStep="goToStep"
                  ref="CommonComponent"
                />
              </v-stepper-content>
              <v-stepper-step
                v-if="isPhysicalEvent(false)"
                step="2"
                editable
                :rules="[() => virtual_stepper_validation]"
              >
                {{ $t(`${eventPrefix}.save.step.virtual_configration`) }}
              </v-stepper-step>
              <v-stepper-content
                step="2"
                v-if="isPhysicalEvent(false)"
              >
                <ScreenerVirtualSave
                  :is_vod_event="is_vod_event"
                  :screener.sync="screener"
                  :eventPrefix="eventPrefix"
                  :virtual_stepper_validation.sync="virtual_stepper_validation"
                  :seatsDialog.sync="seatsDialog"
                  @goToStep="goToStep"
                  @get="get()"
                  ref="VirtualComponent"
                />
              </v-stepper-content>
              <v-stepper-step
                v-if="
                  !is_vod_event && isPhysicalEvent(true)
                "
                step="3"
                editable
                :rules="[() => venue_stepper_validation]"
              >
                {{ $t("screener.save.step.venue_configration") }}
              </v-stepper-step>
              <v-stepper-content
                v-if="
                  !is_vod_event && isPhysicalEvent(true)
                "
                step="3"
              >
                <ScreenerVenueSave
                  :is_vod_event="is_vod_event"
                  :screener.sync="screener"
                  :eventPrefix="eventPrefix"
                  :venue_stepper_validation.sync="venue_stepper_validation"
                  ref="VenueComponent"
                />
              </v-stepper-content>

              <!-- Be-In Configuration -->
              <v-stepper-step
                step="4"
                editable
                :rules="[() => venue_stepper_validation]"
                v-if="
                  !is_vod_event && selected_company.id == 8
                "
              >
              <v-layout column wrap>
                  <v-flex xs12>
                    <div class="d-flex align-center">
                        <h4 class="mr-2">{{ $t('screener_chat_room.chat_room_configuration') }}</h4>
                        <v-chip
                          class="mx-0"
                          small
                          color="success"
                          outline
                          v-if="screener.allow_chat_room"
                          >
                            {{ $t('enabled.btn.title') }}
                        </v-chip>
                    </div>

                    <small>{{ $t('screener_chat_room.chat_room_subline') }}</small>
                  </v-flex>
                </v-layout>
              </v-stepper-step>
              <v-stepper-content
                step="4"
                v-if="!is_vod_event && selected_company.id == 8"
              >
                <ScreenerBeInSave
                  :screener.sync="screener"
                  :eventPrefix="eventPrefix"
                />
              </v-stepper-content>
              <!-- Be-In Configuration -->

            </v-stepper>
            <v-card flat class="pl-3">
              <v-card-actions class="">
                <v-layout column wrap>
                  <v-flex v-if="!screener.is_vod_event">
                    <v-switch v-model="screener.is_unlisted">
                      <template v-slot:label>
                        <div>
                          {{ $t(`${eventPrefix}.save.form.unlisted`) }}
                        </div>
                      </template>
                      <template v-slot:append>
                        <v-tooltip top color="white">
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on">mdi-information-outline</v-icon>
                          </template>
                          <div class="grey--text text--darken-3 body-1" v-html="$t(`${eventPrefix}.save.form.unlisted.tooltip`)"></div>
                        </v-tooltip>
                      </template>
                    </v-switch>
                  </v-flex>
                  <v-flex>
                    <v-chip
                      class="mb-4"
                      small
                      :color="screener.published ? 'success' : 'red'"
                      outline
                      >
                      {{ screener.published? $t(`${eventPrefix}.save.form.published`) :$t(`${eventPrefix}.save.form.unpublished`) }}
                    </v-chip>
                  </v-flex>
                  <v-flex>
                    <div v-if="screener.id">
                      <v-btn
                        color="secondary"
                        @click="save('update',true)"
                        >{{ $t(`${eventPrefix}.btn.save_and_publish`) }}</v-btn
                      >
                      <v-btn
                        color="secondary"
                        @click="save('update',false)"
                        >{{ $t(`${eventPrefix}.btn.save_as_draft`) }}</v-btn
                      >
                    </div>
                    <v-btn
                      v-else
                      @click="save('create')"
                      color="secondary"
                      dark
                      >{{ $t(`${eventPrefix}.btn.create_and_close`) }}</v-btn
                    >
                  </v-flex>
                </v-layout>

                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-tab-item>
        <v-tab-item value="virtual">
          <v-tabs
            v-model="virtualTabItem"
            slider-color="primary"
            fixed-tabs
          >
            <v-tab
              v-if="
                !is_vod_event && isPhysicalEvent(false)
              "
              href="#streams"
              >{{ $t(`${eventPrefix}.save.streams.title`) }}</v-tab
            >
             <v-tab
              v-if="isPhysicalEvent(false)"
              href="#registrants"
              @click="$refs.consumer_list.getDataFromApi()"
              >{{ $t(`${eventPrefix}.save.registrant.title`) }}</v-tab
            >
          </v-tabs>
          <v-tabs-items v-model="virtualTabItem">
            <v-tab-item v-if="!is_vod_event" value="registrants">
              <ConsumerList :screener="screener" ref="consumer_list"/>
            </v-tab-item>
            <v-tab-item v-if="!is_vod_event" value="streams">
              <ScreenerStreams
                :screener_id="screener.id"
                :screener="screener"
                v-if="virtualTabItem == 'streams'"
              />
            </v-tab-item>
         </v-tabs-items>
        </v-tab-item>
        <v-tab-item value="physical">
          <v-tabs
            v-model="physicalTabItem"
            slider-color="primary"
            fixed-tabs
          >
           <v-tab
              v-if="isPhysicalEvent(true)"
              href="#seats"
              @click="$refs.seats.getSeatsStatus()"
              >{{ $t(`screener.save.tab.seats`) }}</v-tab
            >
            <v-tab
              v-if="isPhysicalEvent(true)"
              href="#bookings"
              @click="$refs.bookings.getDataFromApi()"
              >{{ $t(`screener.save.tab.bookings`) }}</v-tab
            >
          </v-tabs>
          <v-tabs-items v-model="physicalTabItem">
            <v-tab-item value="seats">
              <Seats :allSeatsStatus.sync="allSeatsStatus" :screener="screener" @onSeatsUpdate="get()" ref="seats" @goToPhysicalVenueStep="goToPhysicalVenueStep" />
            </v-tab-item>
            <v-tab-item value="bookings">
              <Bookings :total_attendees.sync="total_attendees" :screener="screener" ref="bookings" />
            </v-tab-item>
          </v-tabs-items>
        </v-tab-item>
         <v-tab-item v-if="is_vod_event" value="vod_registrants">
              <ConsumerList :screener="screener" />
            </v-tab-item>
      </v-tabs-items>
    </div>
    <UpdateSeats
      v-if="
        screener.id &&
        seatsDialog &&
        screener.screening_type !== DEFINES.SCREENING_PLAN_TYPE.ENTERPRISE
      "
      :seatsDialog.sync="seatsDialog"
      :screener="screener"
      :company="selected_company"
      @updateScreener="updateScreener"
      @redirectTo="goToMonetization"
    ></UpdateSeats>
  </div>
</template>

<script>
import DEFINES from "@/defines";
import rules from "@/validation";
import i18n from "@/i18n";
import { mapState, mapGetters } from "vuex";
import moment from "moment";

import { buildHeaders } from "../../api/_manager";
import ConsumerList from "@/components/ConsumerList";
import { utcToTz, tzToUtc, calDateToMin, calMinToDate } from "@/helper";
import ScreenerPreviewLink from "@/components/screener/ScreenerPreviewLink";
import UpdateSeats from "@/components/screener/UpdateSeats";
import Seats from "@/components/screener/physicalEvent/Seats";
import Bookings from "@/components/screener/bookings/Bookings";
import EmbedScreener from "@/components/screener/EmbedScreener";
import { currencySymbol ,getPricingListFromApi} from "@/mixins/monetization";
import ScreenerStreams from "@/components/screener/Streams";
import ScreenerOverview from "@/components/screener/Overview";

import ScreenerCommonSave from "@/components/screener/save/Common";
import ScreenerVirtualSave from "@/components/screener/save/Virtual";
import ScreenerVenueSave from "@/components/screener/save/Venue";
import ScreenerBeInSave from "@/components/screener/save/BeInConfiguration";

export default {
  name: "ScreenerSave",
  data() {
    return {
      rules,
      moment,
      step: 0,
      parentStepperStep: 1,
      common_stepper_validation: true,
      virtual_stepper_validation: true,
      venue_stepper_validation: true,
      parentTabItem: "overview",
      virtualTabItem: "registrants",
      physicalTabItem: "bookings",
      loader: false,
      items: ["Web", "Shopping", "Videos", "Images"],
      screeningSrc: null,
      uploaded_thumbnail_id: null,
      allSeatsStatus:{},
      screener: {
        title: null,
        screening_type: this.getScreeningType(),
        film_id: null,
        film_ids: [],
        description: null,
        thumbnail_url: null,
        logo: null,
        venue: null,
        screening_starts_at: null,
        screening_ends_at: null,
        registration_starts_at: null,
        registration_ends_at: null,
        screening_tolerance: null,
        limitation: this.getSeatLimitation(),
        is_external_src: false,
        external_url: null,
        qa_info: this.initializeQaInfo(),
        uploaded_logo: null,
        published: false,
        is_unlisted: false,
        geo_blocking: this.initializeGeoBlocking(),
        event_configuration: this.initializeEventConfig(),
        monetization_enabled: false,
        monetization: this.initializeMonetization(),
        pre_roll: null,
        payment_charges: null,
        donation: this.initializeDonation(),
        donation_enabled: false,
        physical_venue_id: null,
        physical_venue_seats: [],
        default_seat_price: null,
      },
      screening_type: DEFINES.SCREENING_TYPE.SINGLE_FILM_SCREENING,
      pricing_type: DEFINES.PREMIUM_SCREENING_PRICING_TYPE.NORMAL,
      seatsDialog: false,
      simulateAlertSnackbar: false,
      seatLimitAlert: true,
      is_media_available: false,
      total_attendees:null,
    };
  },
  components: {
    ConsumerList,
    ScreenerPreviewLink,
    UpdateSeats,
    EmbedScreener,
    Seats,
    Bookings,
    ScreenerStreams,
    ScreenerOverview,

    ScreenerCommonSave,
    ScreenerVirtualSave,
    ScreenerVenueSave,
    ScreenerBeInSave
  },
  mixins: [currencySymbol,getPricingListFromApi],
  computed: {
    ...mapGetters("company", {
      selected_company_id: "getSelected",
      timezone: "getSelectedCompanyTimezone",
      selected_company: "getSelectedCompany",
    }),

    ...mapState({
      films: (state) => state.film.selection_list,
      countries: (state) => state.country.list,
    }),

    userRoleInCompany() {
      return this.$store.getters["company/userRoleInCompany"](
        this.selected_company_id
      );
    },
    is_vod_event() {
      return this.$route.query && this.$route.query.isVodEvent ? true : false;
    },
    eventPrefix() {
      return this.$route.query && this.$route.query.isVodEvent
        ? "vod"
        : "screener";
    },
  },

  mounted() {
    // this.parentTabItem =
    //   this.$route.name == 'screener.save' ? 'details' : 'details';
    this.getCompany()
    this.get();
    this.getCountries();
    this.getVenues();
    this.getPricingListFromApi();
  },
  watch: {
    common_stepper_validation(newVal, oldVal) {
      if (newVal == false) {
        this.parentStepperStep = 1;
      }
    },
    virtual_stepper_validation(newVal, oldVal) {
      if (newVal == false) {
        this.parentStepperStep = 2;
      }
    },
    venue_stepper_validation(newVal, oldVal) {
      if (newVal == false) {
        this.parentStepperStep = 3;
      }
    },
  },
  methods: {
    getSeatLimitation() {
      return this.$store.state.company.company &&
        this.$store.state.company.company.is_screening_pricing_enterprise
        ? this.$store.state.company.company.max_allowed_seats
        : DEFINES.PREMIUM_SCREENING_MIN_SEATS;
    },
    getScreeningType() {
      return this.$store.state.company.company &&
        this.$store.state.company.company.is_screening_pricing_enterprise
        ? DEFINES.SCREENING_PLAN_TYPE.ENTERPRISE
        : DEFINES.SCREENING_PLAN_TYPE.FREE;
    },
    goToStep(step) {
      this.parentStepperStep = step;
    },
    goToPhysicalVenueStep(step){
      this.physicalTabItem = step;
      this.$refs.bookings.getDataFromApi()
    },
    setPreRoll(pre_roll) {
      this.screener.pre_roll = pre_roll;
    },
    async get() {
      if (this.$route.params.screener_id == undefined) {
        return;
      }

      if(this.$route.params.default_tab != undefined){
        this.parentTabItem = this.$route.params.default_tab;
      }
      this.loder = true;
      let result = await this.$store.dispatch("screener/get", {
        id: this.$route.params.screener_id,
      });

      var screener = Object.assign({}, result);
      /**
       * convert utc time to company timezone
       * Can't convert it in input as user is filling his company timezone
       */
      if (screener.registration_starts_at) {
        screener.registration_starts_at = utcToTz(
          screener.registration_starts_at,
          this.timezone
        );
      }
      if (screener.registration_ends_at) {
        screener.registration_ends_at = utcToTz(
          screener.registration_ends_at,
          this.timezone
        );
      }
      if (screener.screening_starts_at) {
        screener.screening_starts_at = utcToTz(
          screener.screening_starts_at,
          this.timezone
        );
      }
      if (screener.screening_ends_at) {
        screener.screening_ends_at = utcToTz(
          screener.screening_ends_at,
          this.timezone
        );
      }

      if (screener.screening_tolerance) {
        screener.screening_tolerance = calMinToDate(
          screener.screening_starts_at,
          screener.screening_tolerance
        );
      }
      if (!screener.geo_blocking) {
        screener.geo_blocking = this.initializeGeoBlocking();
      }
      if (!screener.event_configuration) {
        screener.event_configuration = this.initializeEventConfig();
      }

      if(!screener.qa_info){
        screener.qa_info = this.initializeQaInfo()
      }
      // Need to insert empty schema in case of existing/old screening
      if (!screener.monetization) {
        screener.monetization = this.initializeMonetization();
      } else {
        // Need to check if any plan missing then insert empty schema just for binding
        const definedPricing = this.initializeMonetization();
        for (var key in definedPricing) {
          if (!screener.monetization.hasOwnProperty(key)) {
            screener.monetization[key] = definedPricing[key];
          }
        }
      }
      this.screening_type =
        screener.film_ids && screener.film_ids.length > 1
          ? DEFINES.SCREENING_TYPE.MULTI_FILM_SCREENING
          : DEFINES.SCREENING_TYPE.SINGLE_FILM_SCREENING;

      // event consider available for simulation when media is available at server
      this.is_media_available =
        screener.film_ids && screener.film_ids.length ? true : false;

      this.screener = screener;
      this.screeningSrc = screener.is_external_src
        ? DEFINES.SCREENING_SRC.EXTERNAL
        : DEFINES.SCREENING_SRC.INTERNAL;
      //this.setFilm(screener.film_id);

      this.simulateAlertSnackbar =
        new Date(this.screener.screening_starts_at) >= new Date();
      new Date(this.screener.screening_starts_at) >= new Date() ? true : false;

      if (screener.donation == null) {
        this.screener.donation = this.initializeDonation();
      }

      // this.screener.allow_chat_room = true
      if (!screener.chat_room) {
        this.screener.chat_room = {
          max_members: DEFINES.CHAT_ROOM.DEFAULT_PARTICIPANTS,
          group_chat_enabled: false,
        }
      }

      this.loader = false;
    },

    async getVenues() {
      try {
        await this.$store.dispatch("venue/list");
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },

    async setFilm(film_id) {
      try {
        await this.$store.dispatch("film/setEditableFilm", {
          id: film_id,
        });
        await this.$store.dispatch("files/get", {
          model_type: "film",
          model_id: film_id,
        });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },

    // Validation should work step wise
    validateSave() {
      switch(this.screener.event_type)
      {
        case DEFINES.SCREENER_TYPE.PHYSICAL :
          return (this.$refs.CommonComponent.validateSave() && this.$refs.VenueComponent.validateSave());
        case DEFINES.SCREENER_TYPE.VIRTUAL :
          return (this.$refs.CommonComponent.validateSave() &&this.$refs.VirtualComponent.validateSave())
        case DEFINES.SCREENER_TYPE.VIRTUAL_AND_PHYSICAL :
          return (this.$refs.CommonComponent.validateSave() && this.$refs.VirtualComponent.validateSave() && this.$refs.VenueComponent.validateSave())
        default:
          return false;
      }
      return false;
    },

    async save(operation,isPublished = false) {
      if (isPublished && !this.validateSave()) {
        return false;
      }
      try {
        this.screener.published = isPublished;
        var screener = Object.assign({}, this.screener);
        screener.uploaded_thumbnail_id = this.uploaded_thumbnail_id;
        screener.screening_tolerance = calDateToMin(
          screener.screening_starts_at,
          screener.screening_tolerance
        );
        // convert company timezone to UTC
        screener.registration_starts_at = tzToUtc(
          screener.registration_starts_at,
          this.timezone
        );
        screener.registration_ends_at = tzToUtc(
          screener.registration_ends_at,
          this.timezone
        );
        screener.screening_starts_at = tzToUtc(
          screener.screening_starts_at,
          this.timezone
        );
        screener.screening_ends_at = tzToUtc(
          screener.screening_ends_at,
          this.timezone
        );

        var response = await this.$store.dispatch(
          "screener/" + operation,
          screener
        );

        this.$router.push({
          name: this.is_vod_event ? "vod.list" : "screener.list",
          params: {
            company_id: this.selected_company_id,
          },
          query: screener.is_vod_event ? { isVodEvent: true } : null,
        });
        this.$store.dispatch("app/showMessage", {
          message: i18n.t(`${this.eventPrefix}.save.success.message`),
          color: this.DEFINES.SNACKBAR_SUCCESS_COLOR,
        });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },

    initializeGeoBlocking() {
      return {
        blocking_for: null,
        city: null,
        blocking_type: null,
        country_code: [],
      };
    },
    initializeEventConfig() {
      return {
        auto_play: true,
        no_skip: false,
        no_pause: false,
        movie_switching_enabled: true,
        is_full_screen_mode: false
      };
    },
    initializeDonation() {
      return {
        email: "",
        purpose: "",
      };
    },

    initializeQaInfo(){
      return {
          title: null,
          message: null,
          zoom_link: null,
          meeting_id: null,
          password: null,
        }
    },
    initializeMonetization() {
      let SINGLE_PURCHASE_KEY =
        DEFINES.MONETIZATION.PRICING_TYPE.SINGLE_PURCHASE;
      var GROUP_PURCHASE_KEY = DEFINES.MONETIZATION.PRICING_TYPE.GROUP_PURCHASE;
      let VOD_PURCHASE_KEY = DEFINES.MONETIZATION.PRICING_TYPE.VOD_PURCHASE;

      let pricing_plans = {};
      pricing_plans[SINGLE_PURCHASE_KEY] = [
        {
          type: null,
          price: null,
          currency: this.$store.state.company.company.currency,
          screening_ids: [],
        },
      ];
      pricing_plans[VOD_PURCHASE_KEY] = [
        {
          type: DEFINES.MONETIZATION.PRICING_TYPE.VOD_PURCHASE,
          price: null,
          currency: this.$store.state.company.company.currency,
          screening_ids: [],
        },
      ];
      pricing_plans[GROUP_PURCHASE_KEY] = [];
      return pricing_plans;
    },

    updateScreener(sc) {
      this.screener.limitation = sc.limitation;
      this.screener.screening_type = sc.screening_type;
      this.screener.payment_charges = sc.payment_charges;
    },

    async getCountries() {
      try {
        this.loader = true;
        await this.$store.dispatch("country/list");
        this.loader = false;
      } catch (error) {
        this.loader = false;
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },

    isPhysicalEvent(physical_event){
      if(physical_event){
        return ( this.screener.event_type == DEFINES.SCREENER_TYPE.PHYSICAL || this.screener.event_type == DEFINES.SCREENER_TYPE.VIRTUAL_AND_PHYSICAL)
      }else{
        return ( this.screener.event_type != DEFINES.SCREENER_TYPE.PHYSICAL || this.screener.event_type == DEFINES.SCREENER_TYPE.VIRTUAL_AND_PHYSICAL)
      }
    },
    goToMonetization(){
      this.parentTabItem = "details"
      this.goToStep(2);
      if(this.$refs.VirtualComponent){
        this.$refs.VirtualComponent.goToStep(this.is_vod_event ? 7 : 8);
      }
    },
    getCompany() {
      this.$store.dispatch("company/get", {
            id: this.$route.params.company_id
      })
    }
  },
};
</script>

<style scoped>
>>> .v-toolbar__extension {
  padding: 0 0 !important;
}
>>> .v-toolbar__content {
  padding: 0 16px !important;
}

.display_contents {
  display: contents;
}

.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 1;
  position: absolute;
  width: 100%;
}
>>> .theme--light.v-stepper .v-stepper__step__step, .theme--light.v-stepper .v-stepper__step__step .v-icon {
    color: transparent !important;
}
</style>
